<template>
  <div>
    <div ref="pages"></div>
    <div
      v-infinite-scroll="loadMore"
      :infinite-scroll-disabled="isLoading || !hasMore"
      infinite-scroll-distance="800"
    ></div>
    <div v-if="isLoading" class="p-4 text-center">
      <div class="lds-ripple text-project-500 scale-75"><div></div><div></div></div>
    </div>
    <div v-if="failed && hasMore" class="changelog-pager">
      <slot></slot>
    </div>
  </div>
</template>

<script>
// The full build, as in packs/application.js: plain "vue" is the runtime-only
// build, which can't compile the server HTML and renders every page empty.
import Vue from "vue/dist/vue.esm";
import guardVueDelimiters from "../vue_delimiter_guard";
var infiniteScroll = require("vue-infinite-scroll");

export default {
  directives: { infiniteScroll },
  props: {
    url: { type: String, required: true },
    nextPage: { type: Number, required: true },
  },
  data() {
    return {
      page: this.nextPage,
      hasMore: true,
      isLoading: false,
      failed: false,
      chunks: [],
    };
  },
  beforeDestroy() {
    this.chunks.forEach((chunk) => chunk.$destroy());
  },
  methods: {
    async loadMore() {
      if (this.isLoading || !this.hasMore) return;
      this.isLoading = true;
      this.failed = false;
      try {
        const url = new URL(this.url, window.location.origin);
        url.searchParams.set("page", this.page);
        const response = await fetch(url, {
          headers: { Accept: "application/json" },
          credentials: "same-origin",
        });
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        const data = await response.json();
        const added = this.append(data.html);
        this.page = data.next_page;
        this.hasMore = data.has_more;
        // A page made only of entries already on screen (one was published
        // mid-scroll and shifted the offset) leaves nothing new to scroll
        // past, so the scroll trigger would never fire again.
        if (added === 0 && this.hasMore) {
          this.$nextTick(() => this.loadMore());
        }
      } catch (e) {
        this.failed = true;
      } finally {
        this.isLoading = false;
      }
    },
    append(html) {
      const chunk = document.createElement("div");
      chunk.className = "changelog-pager__page";
      chunk.innerHTML = html;
      Array.from(chunk.children).forEach((entry) => {
        if (entry.id && document.getElementById(entry.id)) entry.remove();
      });
      const added = chunk.children.length;
      if (added === 0) return 0;
      this.$refs.pages.appendChild(chunk);
      // The page's Vue root only compiled the HTML that was there on load;
      // each appended page needs its own instance for reactions, date
      // tooltips and copy-link to work. parent hands down i18n and the store.
      guardVueDelimiters(chunk);
      this.chunks.push(new Vue({ parent: this, el: chunk, delimiters: ["${", "}"] }));
      return added;
    },
  },
};
</script>
